import * as app from 'actions/app';
import * as chat from 'actions/chat/';
import * as companion from 'actions/chat/companion';
import MobileDetect from 'mobile-detect';
import { useDispatch } from 'react-redux';

export const initialState = {
  isMobile: false,
  mounted: false,
  ended: false,
  token: undefined,
  requestLoading: false,
  requestError: undefined,
  userTimezoneOffset: undefined,
  companionAvailable: false,
  embedded: false,
  isOutOfSchedule: undefined,
  isOutOfScheduleMessage: undefined,
};

const reducer = (state = initialState, action) => {
  if (action.type === app.USER_AUTHENTICATE_FAIL || action.type === chat.START_FAIL) {
    return { ...state, requestLoading: false, requestError: action.error };
  }

  switch (action.type) {
    case app.MOUNTED:
      return { ...state, 
        mounted: true, 
        userTimezoneOffset: action.userTimezoneOffset,
        isMobile: !!(new MobileDetect(window.navigator.userAgent).mobile()),
        embedded: action.embedded,
      };
    case app.USER_AUTHENTICATE_REQUEST:
      return { ...state, requestLoading: true, requestError: undefined };
    case app.START:
      return { ...state, requestLoading: false, requestError: undefined };
    case app.END:
      return { ...state, ended: true };
    case app.RESET:
      return { ...initialState };
    case app.USER_AUTHENTICATE:
      return { ...state, token: action.token };
    case companion.CHECK_AVAILABILITY:
      return { ...state, companionAvailable: action.available };
    case app.IS_OUT_OF_SCHEDULE:
      return { ...state, isOutOfSchedule: action.schedule.activeNow };
    case app.IS_OUT_OF_SCHEDULE_MESSAGE:
      return { ...state, isOutOfScheduleMessage: action.scheduleMessage.outOfScheduleMessage}  
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./reducers/app.js